export default "__VITE_ASSET__Bg_TlrRW__ 400w, __VITE_ASSET__sh0G1G82__ 800w, __VITE_ASSET__Bp9DDJMh__ 1200w";